import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";

class StockOpnameFooter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        console.log(this.props);
        
        const isQr = this.props.tab === "with_qr";
        return (
            <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px margin-top-20px">
                <div id="grid-1"></div>
                <div id="grid-2"></div>
                <div id="grid-3 gap-20px">
                    <p style={{textAlign: "left"}}>
                        Total Proses:
                    </p>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{textAlign: "left", width: "40%"}}
                        >
                            Total Jumlah Item:
                        </p>
                        <SimpleInput
                            containerclassname="margin-bottom-none"
                            id="input_text_tgl_stock_opname"
                            name="jmlItem"
                            value={this.props.totalProcess?.totalItem}
                            readOnly={true}
                        />
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{textAlign: "left", width: "40%"}}
                        >
                            {`Yang Sudah di ${isQr?"Scan":"Proses"}:`}
                        </p>
                        <SimpleInput
                            containerclassname="margin-bottom-none"
                            id="input_text_tgl_stock_opname"
                            name="jmlItem"
                            value={this.props.totalProcess?.totalScanned}
                            readOnly={true}
                        />
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{textAlign: "left", width: "40%"}}
                        >
                             {`Yang Belum di ${isQr?"Scan":"Proses"}:`}
                        </p>
                        <SimpleInput
                            containerclassname="margin-bottom-none"
                            id="input_text_tgl_stock_opname"
                            name="jmlItem"
                            value={this.props.totalProcess?.totalUnScanned}
                            readOnly={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default StockOpnameFooter;